import { useState } from 'react';
import {
    FormControl,
    FormLabel,
    Box,
    Stack,
    FormErrorMessage,
} from '@chakra-ui/react';
import { Field } from 'formik';
import { useCompanyForm } from '../../hooks/useCompanyForm';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
} from 'components/forms/new/formStyles';
import { FORM_FIELD_PATHS } from '../../constants';

const MFA_OPTIONS = [
    { label: 'Forced', value: true, id: true, name: 'Forced' },
    { label: 'Enabled', value: false, id: false, name: 'Enabled' },
];

const EntityMFADropdown = ({ darkMode, errors }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { formData, updateFormData } = useCompanyForm();

    const handleSelectChange = (item) => {
        updateFormData(FORM_FIELD_PATHS.MFA_ENFORCED, item.value);
    };

    const hasError = !!errors?.mfaEnforced;

    return (
        <FormControl
            sx={{ margin: '0 !important', paddingInline: 4 }}
            isInvalid={hasError}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>MFA</FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={DropDown}
                        id={FORM_FIELD_PATHS.MFA_ENFORCED}
                        name={FORM_FIELD_PATHS.MFA_ENFORCED}
                        data={MFA_OPTIONS}
                        shownValue="label"
                        currentId={formData?.mfaEnforced}
                        selectedId="value"
                        placeholder="Select MFA option"
                        handleSelectChange={handleSelectChange}
                        width="100%"
                        isLoading={false}
                        darkMode={darkMode}
                    />
                </Box>
                {isHovered && (
                    <FieldToolTip
                        label="Select MFA enforcement for this company"
                        ariaLabel="mfa-dropdown-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
            <FormErrorMessage>{errors?.mfaEnforced}</FormErrorMessage>
        </FormControl>
    );
};

export default EntityMFADropdown;
